// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1BjFK","rootSmall":"AddTileButton_rootSmall__35X-t"};